var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lv-timeline"},[_c('timeline',{attrs:{"timeline-items":_vm.chapters,"message-when-no-items":_vm.messageWhenNoItems,"unique-year":true,"order":"desc"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a7db710","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LVTimeline.vue
// module id = 2817
// module chunks = 1